import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    HealthcareProfessional,
    IHealthcareProfessional,
    IHealthcareProfessionalPayload,
} from '../HealthcareProfessional.ts';
import { AppMedError } from '../../../error/AppMedError.ts';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { healthcareProfessionalNewQuery } from '../queries/useGetHealthcareProfessionalNew.tsx';

export function usePostHealthcareProfessional() {
    const queryClient = useQueryClient();

    return useMutation<any, AppMedError, IHealthcareProfessionalPayload>({
        mutationKey: [QueryKeys.healthcareProfessional],
        mutationFn: async (variables: IHealthcareProfessionalPayload) => {
            const id = await HealthcareProfessionalsApi.postHealthcareProfessional(variables);
            const roleCatalogue = await queryClient.ensureQueryData(healthcareProfessionalNewQuery);
            const professional = new HealthcareProfessional(variables as unknown as HealthcareProfessional);
            return {
                ...professional,
                id,
                name: `${professional.firstName} ${professional.lastName}`,
                healthcareProfessionalType:
                    roleCatalogue?.healthcareProfessionalTypeLabel(professional.healthcareProfessionalTypeID) ?? '',
            };
        },
        onSuccess: (healthcareProfessional: IHealthcareProfessional) => {
            queryClient.setQueryData<IHealthcareProfessional>(
                [QueryKeys.healthcareProfessional, healthcareProfessional.id],
                healthcareProfessional,
            );

            queryClient.setQueryData<IHealthcareProfessional[]>([QueryKeys.healthcareProfessionals], (prev) =>
                prev ? [...prev, healthcareProfessional] : [healthcareProfessional],
            );
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionals] });
        },
    });
}
